'use client';

import {withProducts} from '@/api/products';
import {useCategory} from '@/app/selectedCategoryContext';

import {SubcategoryProducts} from './subcategory-products/subcategory-products';
import {CategoryProducts} from './category-products/category-products';

import styles from './feed.module.css';
import {CategoriesMobile} from '../navbar/navbar';
import {useInfo} from '@/app/infoContext';
import {ClientProducts, ClientSubcategory} from '@/api/types/products';

export const Feed = withProducts(({products, isAvailable}) => {
    const {isMobile} = useInfo();

    const {state} = useCategory();

    if (isMobile) {
        const categoryToShow =
            state.categoryId !== -1 ? products.filter((category) => category.id === state.categoryId) : products;

        const subcategoryToShow =
            state.subcategoryId && state.categoryId && 'subcategories' in products[state.categoryId]
                ? (
                      products[state.categoryId] as ClientProducts & {
                          subcategories: Array<ClientSubcategory>;
                      }
                  ).subcategories.filter((sub) => sub.id === state.subcategoryId)
                : undefined;

        console.log(subcategoryToShow);

        return (
            <div>
                <CategoriesMobile />
                {state.subcategoryId
                    ? subcategoryToShow?.map((product) => (
                          <SubcategoryProducts
                              subcategory={product}
                              key={product.id}
                              isAvailable={isAvailable}
                              withTitle={!subcategoryToShow}
                          />
                      ))
                    : categoryToShow.map((products) => (
                          <CategoryProducts
                              products={products}
                              key={products.id}
                              isAvailable={isAvailable}
                              withTitle={!categoryToShow}
                          />
                      ))}
            </div>
        );
    }

    return (
        <div className={styles.feed} aria-label="Лента продуктов">
            {products.map((products) => (
                <CategoryProducts products={products} key={products.id} isAvailable={isAvailable} />
            ))}
        </div>
    );
});
